import styles from './SpeakingHead.module.sass';
import Image from "next/image";
import cn from "classnames";
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
const SpeakingHead = ({ children, className, gsapClassName, parentStyle, speaker, scrollToSeeMore = false, ...props}) => {

	return (
			<div className={cn(styles.speaking_head, parentStyle.speakinghead, gsapClassName, className)} {...props}>
				<Image className={cn(styles.head, parentStyle.head)}
				       src={speaker === SpeakingHeadStyles.LAWYER ? '/images/SpeakingHead/lawyer_head.png' : '/images/SpeakingHead/sacha_head.png'}
                       alt={speaker === SpeakingHeadStyles.LAWYER ? "Lawyer Head" : "Sacha Head"}
                       quality={100} width={256} height={256}/>

				<div className={cn(styles.speach_bubble, parentStyle.speach_bubble)}>
					{children}

					{scrollToSeeMore && <div className={cn(styles.scroll_to_see_more, parentStyle.scroll_to_see_more)}>
						<span>Scroll pour la suite</span>
						<Arrow_SVG className={styles.arrow} color={'#EEEED1'}/>
					</div>}
				</div>
			</div>
	)
}
export default SpeakingHead;

export const SpeakingHeadStyles = {
	LAWYER: 1,
	SACHA: 2,
}